// Webpack Imports
import * as bootstrap from 'bootstrap';
import { animate } from './modules/animations'
import VanillaTilt from 'vanilla-tilt';
import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';
import Quill from 'quill';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );
	
	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();



document.addEventListener("click", (e) => {

	if(e.target.closest(".has-dropdown")){
		e.preventDefault();

		let parentEl = e.target.closest(".has-dropdown")
		const megaID = parentEl.dataset.ssmega;
		console.log(`.parent-${megaID}`)
		let megaEl = document.querySelector(`.mega-menu .parent-${megaID}`).closest(".mega-menu")

		if(megaEl.classList.contains("active")){

			let prevActive = document.querySelectorAll(".mega-menu.active:not(.more-sub-menu)")
			let prevActiveNav = document.querySelectorAll(".more-nav.has-dropdown.active")
			
			prevActive.forEach(element => {
				element.classList.remove("active");
			});
			
			prevActiveNav.forEach(element => {
				element.classList.remove("active");
			});
			document.querySelector("#header-menu-indicator-track")?.classList.remove("active");
			parentEl.classList.remove("active")
			megaEl.classList.remove("active");
			document.querySelector("#navbar").classList.remove("mega-active");	

		}else{
			
			if(document.querySelector("#more-mega.active") && e.target.closest("#more-mega")){

				let prevActive = document.querySelectorAll(".mega-menu.active:not(.more-sub-menu)")
				let prevActiveNav = document.querySelectorAll(".more-nav.has-dropdown.active")
				
				prevActive.forEach(element => {
					element.classList.remove("active");
				});
				
				prevActiveNav.forEach(element => {
					element.classList.remove("active");
				});


			}else{

				let prevActive = document.querySelectorAll(".mega-menu.active")
				let prevActiveNav = document.querySelectorAll(".has-dropdown.active")
				
				prevActive.forEach(element => {
					element.classList.remove("active");
				});
				
				prevActiveNav.forEach(element => {
					element.classList.remove("active");
				});
				
				let moreMenu = document.querySelector("#more-mega.active")
				if( moreMenu ){ moreMenu.classList.remove("active");}


				
				document.querySelector("#navbar").classList.add("mega-active");
				moveIndicator(parentEl, true);	

			}

			parentEl.classList.add("active");
			megaEl.classList.add("active");	
					

		}

	}

	if(e.target.closest('.form-cta-button')){
		let targetElement = e.target.closest('.form-cta-button')
		document.querySelector(".form-cta-button.selected")?.classList.remove("selected")
		targetElement.classList.add("selected")
	}
})


const handleMouseEnter = (event) => {
	const isActive = event.target.classList.contains("active")
	if(document.querySelector(".mega-menu.active")){
		moveIndicator(event.target, isActive)
	}
}


const headerDropdowns = document.querySelectorAll("#navbar .has-dropdown")
headerDropdowns.forEach(dropdown => {
	dropdown.addEventListener('mouseenter', handleMouseEnter)
});

document.querySelector("#navbar").addEventListener("mouseleave", (e)=>{

	if(document.querySelector(".mega-menu.active")){
		moveIndicator(document.querySelector("#navbar .has-dropdown.active"))
	}
	
})




// const moveIndicator = (navbarElement, navItemElement) => {
const moveIndicator = (navItemElement, active = false) => {


		let navbarRect = document.querySelector("#navbar").getBoundingClientRect()
		let parentDivRect = navItemElement.getBoundingClientRect()
		let offset = parentDivRect.left - navbarRect.left

		// Getting the center of dropdown menu item by removing right padding (used for dropdown caret), 
		// dividing by 2 and minusing half of the triangle indicator
		let elWidth = (parentDivRect.width - 14) / 2 - 7;

		let finalXpos = offset + elWidth

		
		let indicatorColor = navItemElement.classList.contains("red") ||  navItemElement.classList.contains("blue") ? "red" : "brand" 
		if(indicatorColor == "red"){
			indicatorColor = navItemElement.classList.contains("red") ? "red" : "blue" 
		}

		document.querySelector("#header-menu-indicator").classList.remove("blue", "red", "brand")
		// if(active){
			document.querySelector("#header-menu-indicator").classList.add(indicatorColor)
		// }

		document.querySelector("#header-menu-indicator").style.transform = `translateX(${finalXpos}px)`
		setTimeout(() => {
			document.querySelector("#header-menu-indicator-track").classList.add("active");	
		}, 10);
		
}

animate();


const element = document.querySelector(".elementor-element-9fb75c1.ssFadeInRight .elementor-widget-container");
VanillaTilt.init(element, {
	perspective: 2000,
	 glare: true,
	 "max-glare": 0.3, 
	 reverse: true,
	 reset: false, 
	 "mouse-event-element":  document.querySelector(".elementor-element-d63c753"),
	//  startX: 7,
	//  startY: -13
	max: 10,
});
// element.addEventListener("tiltChange", (e)=>{console.log(e)});




//close all mega-menu on click outside
document.addEventListener("click", (e)=>{	
	if(!e.target.closest(".mega-menu") && !e.target.closest(".has-dropdown")){
		document.querySelector(".mega-menu.active")?.classList.remove("active")
		document.querySelector("#header-menu-indicator-track")?.classList.remove("active");
		document.querySelector("#navbar").classList.remove("mega-active");
	}
})


//slide mobile menu right to left to reveal mega menu
document.querySelector("#navbar-toggler").addEventListener("click", (e)=>{
	document.querySelector("#mobile-menu").classList.toggle("active");
	document.body.classList.toggle("menu-open");
})


//slide mobile menu to reveal sub menu
document.querySelectorAll("#mobile-menu .has-submenu").forEach((el)=>{
	el.addEventListener("click", (e)=>{
		e.preventDefault();
		const mobileID = el.dataset.ssmobile;
		// console.log("howdy")
		document.querySelector(`#mobile-menu .parent-${mobileID}`)?.closest(".mobile-sub-menu")?.classList.add("active");
		// document.querySelector(`#${mobileID}`)?.classList.add("active");
		document.querySelector(".mobile-container")?.classList.add("active");
	})
})
// document.querySelectorAll("#mobile-menu .has-submenu").forEach((el)=>{
// 	el.addEventListener("click", (e)=>{
// 		e.preventDefault();
// 		const mobileID = el.dataset.mobile;
// 		// console.log("howdy")
// 		document.querySelector(`#${mobileID}`)?.classList.add("active");
// 		document.querySelector(".mobile-container")?.classList.add("active");
// 	})
// })


let accordionContainers = document.querySelectorAll(".mobile-accordions");
accordionContainers.forEach((container)=>{
	new Accordion(container, {
		duration: 250,
		// openOnInit: [0]
	})
})







document.querySelector(".floating-mobile-back-btn")?.addEventListener("click", (e)=>{
	document.querySelector(".mobile-container.active")?.classList.remove("active");
	setTimeout(()=>{
		document.querySelector(".mobile-sub-menu.active")?.classList.remove("active");
	}, 200)
	
})


let titleBackBars = document.querySelectorAll(".mobile-sub-menu .back-btn")

titleBackBars.forEach((bar)=>{
	bar.addEventListener("click", (e)=>{
		// e.preventDefault();
		document.querySelector(".mobile-container.active")?.classList.remove("active");
		setTimeout(()=>{
			document.querySelector(".mobile-sub-menu.active")?.classList.remove("active");
		}, 200)
		
	})
})


const createFooterAccordions = () => {
	let accordionContainersFooter = Array.from(document.querySelectorAll(".footer-menu"));
	let footerAccordions = new Accordion(accordionContainersFooter, {duration: 250})

	return footerAccordions
}

const destroyFooterAccordions = (accordions) => {
	accordions.forEach((accordion)=>{
		accordion.destroy()
	})
}

let footerAccordions = null

if(window.innerWidth < 991){
	footerAccordions = createFooterAccordions()
}




//Mobile Viewport hackery
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {

  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  if(window.innerWidth < 991){
	if(!footerAccordions){
		footerAccordions = createFooterAccordions()
	}
  }else{
	if(footerAccordions){ destroyFooterAccordions(footerAccordions); footerAccordions = null }
  }
});

// Toogle Feed Widget
const toggleFeeds = document.querySelectorAll('.elementor-widget-toggle-feed');
if(toggleFeeds){
	toggleFeeds.forEach((feed) =>{
		let container = feed.querySelector('.toggle-feed');
		new Accordion(container, {
			duration: 250,
			showMultiple: true,
			triggerClass: 'toggle-feed-tab-title',
		})
	})
}


